// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4195":"9709c253","9315":"6ab63df8"}[chunkId] + ".chunk.css";
};